import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useProcessorFeeTable from "./hooks/useProcessorFeeTable";  
  
const ProcessorFeeTable = () => {  
  const processorFeeTableData = useProcessorFeeTable();  
  
  return (  
    <div class="container container-fluid">  
      {processorFeeTableData.leftButtons.length > 0 && <ButtonsSection
            ctaButtons={processorFeeTableData.leftButtons}
            align="left"
      />}
      <div className="header-section">  
        <h1>  
          {processorFeeTableData.screen_title} -{" "}  
          <span className="heading-cod">  
            {processorFeeTableData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={processorFeeTableData.formFields}  
        paramsData={processorFeeTableData.paramsData}  
        updataParamData={processorFeeTableData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={processorFeeTableData.ctaButtons} />  
      <DisplayTable  
        data={processorFeeTableData.data}  
        parmKey={processorFeeTableData.parmKey}  
        menuOptions={processorFeeTableData.menuOptions}  
        tableHeaders={processorFeeTableData.columnDef}  
        setRowData={processorFeeTableData.setRowData}  
        selectedPriceSchedules={processorFeeTableData.selectedRows}  
        setSelectedPriceSchedules={processorFeeTableData.setSelectedRows}  
        selectMode={processorFeeTableData.selectMode}
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={processorFeeTableData.first}  
          rows={processorFeeTableData.rows}  
          totalRecords={processorFeeTableData.totalRecords}  
          currentPage={processorFeeTableData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={processorFeeTableData.onPageChange}  
        />  
      </div>  
      {processorFeeTableData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={processorFeeTableData.isConfirmationModalOpen}  
          onRequestClose={processorFeeTableData.closeConfirmationModal}  
          onBack={processorFeeTableData.closeConfirmationModal}  
          onSave={processorFeeTableData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={processorFeeTableData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default ProcessorFeeTable;